<template>
  <div class="c-app flex-row align-items-center">
    <notifications />
    <CContainer>
      <CRow class="justify-content-center"></Crow>
      <CRow class="justify-content-center">
        <CCol lg="4" md="12" xs="12">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CRow class="justify-content-center">
                  <img src="../../assets/icons/start.png" height="120px" width="130px">
                </CRow>
                <CForm>
                  <h1 class="text-center">Login</h1>
                  <p class="text-center">Acesse a página de checklist</p>
                  <CInput
                    name="useremail"
                    placeholder="E-mail"
                    autocomplete="Digite seu E-mail"
                    v-model="input.email"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    name="password"
                    placeholder="Senha"
                    type="password"
                    autocomplete="Digite sua senha"
                    v-model="input.password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CCol col="12" class="text-center">
                    <CButton
                      class="px-4 btn-lg btn-primary"
                      :disabled="load"
                      @click="login">
                        <span v-if="load">Entrando...</span>
                        <span v-else>Acessar</span>
                        <i v-if="load" class="fa fa-spinner fa-spin ml-2"></i>
                        <i v-else class="fas fa-sign-in-alt ml-2"></i>
                    </CButton>
                  </CCol>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
  import { api, userKey, userCart } from '@/global'
  import notifications from '../templates/notifications.vue'
export default {
  name: 'Login',
  components: {
    notifications
  },
  data() {
    return {
      showError: false,
      message: 'Usuário ou senha inválidos',
      input: {
        email: "",
        password: ""
      },
      load: false
    }
  },
  mounted () {
    const self = this
    window.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        self.login()
      }
    })
  },
  methods: {
    async login() {
      this.load = true
      await api.post('/customer/login', this.input)
      .then(response => {
        const user = response.data.data;
        this.$store.commit('setUser', user)
        localStorage.setItem(userKey, JSON.stringify(user));
        this.$router.replace({ name: 'Dashboard' });
      })
      .catch(error => {
        this.$root.$emit('Notification::show', {
        type: 'danger',
        message: error.response.data.message
      })
    })
    this.load = false
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    box-shadow: -5px 5px 15px #1c1c1c;
  }
</style>
